const LogIn = () => (
  <>
    <path
      fill="currentColor"
      d="M11.658 19.5a7.5 7.5 0 1 0 0-15 .5.5 0 0 1 0-1 8.5 8.5 0 1 1 0 17 .5.5 0 0 1 0-1"
    />
    <path
      fill="currentColor"
      d="M12.867 11.5H4.5a.48.48 0 0 0-.357.143A.48.48 0 0 0 4 12q0 .213.143.357a.48.48 0 0 0 .357.143h8.367l-1.97 1.971a.5.5 0 0 0-.15.338.48.48 0 0 0 .15.364q.159.165.353.168a.5.5 0 0 0 .36-.162l2.613-2.613a.78.78 0 0 0 .242-.566.78.78 0 0 0-.242-.566L11.61 8.822a.483.483 0 0 0-.714.006.5.5 0 0 0-.157.357.5.5 0 0 0 .163.35z"
    />
  </>
)
export default LogIn
